import { render, staticRenderFns } from "./register.vue?vue&type=template&id=005be7bb&"
import script from "./register.vue?vue&type=script&lang=js&"
export * from "./register.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('005be7bb')) {
      api.createRecord('005be7bb', component.options)
    } else {
      api.reload('005be7bb', component.options)
    }
    module.hot.accept("./register.vue?vue&type=template&id=005be7bb&", function () {
      api.rerender('005be7bb', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/auth/register.vue"
export default component.exports